const BASE_URL_A =
  'https://zbw3bnwar6.execute-api.us-east-1.amazonaws.com/dev/';
const BASE_URL_B =
  'https://7l3rsnlkak.execute-api.us-east-1.amazonaws.com/dev/';
const BASE_URL_C =
  'https://j92dsmz3nd.execute-api.us-east-1.amazonaws.com/dev/';
const BASE_URL_D =
  'https://hj185uuju3.execute-api.us-east-1.amazonaws.com/dev/';
const BASE_URL_E =
  'https://wwnzo0qhuj.execute-api.us-east-1.amazonaws.com/dev/';
const BASE_URL_F =
  'https://wpvktkada8.execute-api.us-east-1.amazonaws.com/dev/';
const BASE_URL_G =
  'https://ezm5psq74k.execute-api.us-east-1.amazonaws.com/dev/';

const UPLOAD_URL =
  'https://8x1pz40uv9.execute-api.us-east-1.amazonaws.com/dev/uploadfile/';

const customerIntelligenceUrl =
  'https://ahc3yqaq7i.execute-api.us-east-1.amazonaws.com/customer-intelligence/lead/';

const customerIntelligenceAudienceUrl =
  'https://ahc3yqaq7i.execute-api.us-east-1.amazonaws.com/customer-intelligence/audience';

const receiptOcrUrl =
  'https://dhd67xzre4lgoybfagmdvdzbeu0vapyw.lambda-url.us-east-1.on.aws/';
const receiptOcrApiKey =
  'rcpt_live_6e2a3341b02d23211adfc210f483c2e5a0bc895240c32796';

// const BASE_URL_A =
//   'https://xywfgrd3z1.execute-api.us-east-1.amazonaws.com/prod/';
// const BASE_URL_B =
//   'https://p3nj2i4q83.execute-api.us-east-1.amazonaws.com/prod/';
// const BASE_URL_C =
//   'https://emixjbmpm9.execute-api.us-east-1.amazonaws.com/prod/';
// const BASE_URL_D =
//   'https://bq9eqnjc6h.execute-api.us-east-1.amazonaws.com/prod/';
// const BASE_URL_E =
//   'https://hcyg9wxnql.execute-api.us-east-1.amazonaws.com/prod/';
//   const BASE_URL_F =
//   'https://bq9x1tj1lg.execute-api.us-east-1.amazonaws.com/prod/';

// const UPLOAD_URL =
//   'https://okxvsyvxq1.execute-api.us-east-1.amazonaws.com/prod/uploadFile';

// const BASE_URL_A = 'http://localhost:4000/dev/';
// const BASE_URL_B = 'http://localhost:5000/dev/';
// const BASE_URL_C = 'http://localhost:7000/dev/';
// const BASE_URL_D = 'http://localhost:2000/dev/';
// const BASE_URL_E = 'http://localhost:5058/dev/';
// const BASE_URL_F = 'http://localhost:5070/dev/';
// const BASE_URL_G = 'http://localhost:5080/dev/';
// const UPLOAD_URL = 'http://localhost:3000/dev/uploadfile/';

// const BASE_URL_A = "https://m52aw18288.execute-api.us-east-1.amazonaws.com/prod/"
//const BASE_URL_A = "https://usyokb8dq7.execute-api.us-east-1.amazonaws.com/dev/"

export const environment = {
  production: false,
  apiUrl: BASE_URL_A,
  createDynamicForm: BASE_URL_E + 'createDynamicForm',
  updateDynamicForm: BASE_URL_E + 'updateDynamicForm',
  deleteDynamicForm: BASE_URL_E + 'deleteDynamicForm',
  getDynamicFormList: BASE_URL_E + 'getDynamicFormList',
  getDynamicFormByToken: BASE_URL_E + 'getDynamicFormByToken',
  submitPublicForm: BASE_URL_E + 'submitPublicForm',

  partEApiRoot: BASE_URL_E.replace(/^\s+|\s+$/g, ''),

  // ── AI Agent Flows (part-e) ─────────────────────────────────────────────────
  createAiAgentFlow: BASE_URL_E + 'ai-agent-flows/create',
  updateAiAgentFlow: BASE_URL_E + 'ai-agent-flows/update',
  getAiAgentFlowList: BASE_URL_E + 'ai-agent-flows/list',
  getAiAgentFlowById: BASE_URL_E + 'ai-agent-flows/list',
  deleteAiAgentFlow: BASE_URL_E + 'ai-agent-flows/delete',

  // ── WhatsApp Voice Campaigns (part-e) ───────────────────────────────────────
  createWhatsappVoiceCampaign: BASE_URL_E + 'whatsapp-voice-campaigns/create',
  updateWhatsappVoiceCampaign: BASE_URL_E + 'whatsapp-voice-campaigns/update',
  listWhatsappVoiceCampaigns: BASE_URL_E + 'whatsapp-voice-campaigns/list',
  getWhatsappVoiceCampaignById: BASE_URL_E + 'whatsapp-voice-campaigns/list',
  deleteWhatsappVoiceCampaign: BASE_URL_E + 'whatsapp-voice-campaigns/delete',
  executeWhatsappVoiceCampaignBatch:
    BASE_URL_E + 'whatsapp-voice-campaigns/execute-batch',
  finishWhatsappVoiceCampaign: BASE_URL_E + 'whatsapp-voice-campaigns/finish',
  // manualTriggerWhatsappVoiceCampaign:  BASE_URL_E + 'whatsapp-voice-campaigns/manual-trigger',
  runTelephonyCampaign: BASE_URL_E + 'whatsapp-voice-campaigns/run-telephony',

  //Auth
  loginUser: BASE_URL_A + 'loginUser',
  forgotPassword: BASE_URL_A + 'forgotPassword',
  resetPassword: BASE_URL_A + 'resetPassword',
  verifyOtp: BASE_URL_A + 'verifyOtp',
  validateSession: BASE_URL_D + 'validateSession',

  getAnalytics:
    'https://zt4vunflkg.execute-api.us-east-1.amazonaws.com/test/getAnalytics',

  //Leads
  // getAllLeads:BASE_URL+"getAllLeads",
  getLeadsRocord: BASE_URL_A + 'getLeadRecord',
  getAllLeads: BASE_URL_A + 'getLeads',
  getFilteredLeads: BASE_URL_A + 'getFilteredLeads',
  // createLead:BASE_URL+"createLead",
  createLead: BASE_URL_A + 'createLeads',
  getLead: BASE_URL_A + 'getLead',
  updateLead: BASE_URL_A + 'updateLeads',
  deleteLead: BASE_URL_A + 'deleteLeads',
  createleadsfollowup: BASE_URL_A + 'createleadshistory',
  getLeadsFollowup: BASE_URL_A + 'getleadshistory',
  getLeadsFields: BASE_URL_A + 'getLeadsField',
  addLeadField: BASE_URL_A + 'createLeadsField',
  deleteLeadField: BASE_URL_A + 'deleteLeadsField',
  updateLeadField: BASE_URL_A + 'updateLeadsField',
  createBulkLead: BASE_URL_A + 'createBulkLead',
  updateBulkLead: BASE_URL_A + 'updateBulkLead',
  getLeadAnalytics: BASE_URL_B + 'getLeadAnalytics',

  //Manage Users
  getAllUsers: BASE_URL_A + 'getAllUsers',
  getClient: BASE_URL_A + 'getClient',
  updateClient: BASE_URL_A + 'updateClient',
  findAllUsers: BASE_URL_A + 'getAllUserData',
  createUser: BASE_URL_A + 'createUser',
  getUser: BASE_URL_A + 'getUser',
  updateUser: BASE_URL_A + 'updateUser',
  userModuleDropdownListing: BASE_URL_A + 'userModuleDropdownListing',
  getUserByDepartment: BASE_URL_A + 'getUserByDepartment',
  getUserByDepartmentSchedule: BASE_URL_A + 'getUserByDepartmentSchedule',
  getAllCenter: BASE_URL_A + 'getAllCenter',
  createCenter: BASE_URL_A + 'createCenter',
  updateCenter: BASE_URL_A + 'updateCenter',
  deleteCenter: BASE_URL_A + 'deleteCenter',
  getAllDepartment: BASE_URL_A + 'getAllDepartment',
  createDepartment: BASE_URL_A + 'createDepartment',
  updateDepartment: BASE_URL_A + 'updateDepartment',
  deleteDepartment: BASE_URL_A + 'deleteDepartment',
  getAllRoles: BASE_URL_A + 'getAllRoles',
  createRole: BASE_URL_A + 'createRole',
  updateRole: BASE_URL_A + 'updateRole',
  deleteRole: BASE_URL_A + 'deleteRole',
  getAllPermissions: BASE_URL_A + 'getAllPermissions',
  checkUsernameExists: BASE_URL_C + 'getUserByUsername',
  permanentlyDeleteUser: BASE_URL_D + 'permanentlyDeleteUser',
  reassignAndDeleteUser: BASE_URL_D + 'reassignAndDeleteUser',
  getUserDeletionStatus: BASE_URL_D + 'getUserDeletionStatus',

  //Scheduled
  createSchedule: BASE_URL_A + 'createSchedule',
  getSchedule: BASE_URL_A + 'getSchedule',
  getAllSchedule: BASE_URL_A + 'getAllSchedule',
  bulkSchedule: BASE_URL_A + 'bulkSchedule',
  deleteSchedule: BASE_URL_A + 'deleteSchedule',

  //Subscriber
  createSubscriberList:
    'https://e2cs94lgh8.execute-api.us-east-1.amazonaws.com/dev/createSubscriberList',
  createSubsciberList:
    'https://e2cs94lgh8.execute-api.us-east-1.amazonaws.com/dev/createSubscriberList',
  getSubsciberList:
    'https://e2cs94lgh8.execute-api.us-east-1.amazonaws.com/dev/getSubscriberlist',
  getAllSubsciberList:
    'https://e2cs94lgh8.execute-api.us-east-1.amazonaws.com/dev/getAllSubscriberList',
  deleteSubsciberList:
    'https://e2cs94lgh8.execute-api.us-east-1.amazonaws.com/dev/deleteSubscriberList',

  //Campaign
  createCampaignList:
    'https://e2cs94lgh8.execute-api.us-east-1.amazonaws.com/dev/createCampaignList',
  updateCampaignList:
    'https://e2cs94lgh8.execute-api.us-east-1.amazonaws.com/dev/updateCampaignList',
  getAllCampaignList:
    'https://e2cs94lgh8.execute-api.us-east-1.amazonaws.com/dev/getAllCampaignList',
  deleteCampaignList:
    'https://e2cs94lgh8.execute-api.us-east-1.amazonaws.com/dev/deleteCampaignList',

  //Contact
  //  createContact: "https://usyokb8dq7.execute-api.us-east-1.amazonaws.com/dev/createContact",
  //  updateContact: "https://usyokb8dq7.execute-api.us-east-1.amazonaws.com/dev/updateContact",
  //  getAllContact: "https://usyokb8dq7.execute-api.us-east-1.amazonaws.com/dev/getAllContact",
  //  deleteContact: "https://usyokb8dq7.execute-api.us-east-1.amazonaws.com/dev/deleteContact",

  //template
  getAllTemplates:
    'https://ekofx0jipf.execute-api.us-east-1.amazonaws.com/prod/getAllTemplates',

  //msg
  sendWhatsappMsg: BASE_URL_E + 'sendWhatsappMsg',
  sendMediaTemplateMsg:
    'https://ekofx0jipf.execute-api.us-east-1.amazonaws.com/prod/sendMediaTemplateMsg',
  sendTextTemplateMsg:
    'https://ekofx0jipf.execute-api.us-east-1.amazonaws.com/prod/sendTextTemplateMsg',

  //Appointment
  getAllAppointmentWithCount: BASE_URL_A + 'getAllAppointmentWithCount',
  createAppointment: BASE_URL_A + 'createAppointment',
  getPatient: BASE_URL_A + 'getPatient',
  getAllAppointment: BASE_URL_A + 'getAllAppointment',
  getAllAppointmentByPatientId: BASE_URL_A + 'getAllAppointmentByPatientId',
  getAvailableDays: BASE_URL_A + 'getAvailableDays',
  getSlots: BASE_URL_A + 'getSlots',
  updateAppointment: BASE_URL_A + 'updateAppointment',
  deleteAppointment: BASE_URL_A + 'deleteAppointment',
  checkInOpdPatientData: BASE_URL_A + 'checkInOpdPatientData',
  getAllFreeTimeSlot: BASE_URL_A + 'getAllFreeTimeSlot',

  //Email config
  createEmailConfig: BASE_URL_A + 'createEmailConfig',
  getEmailConfig: BASE_URL_A + 'getEmailConfig',
  updateEmailConfig: BASE_URL_A + 'updateEmailConfig',

  // User Logs
  createUserLog: BASE_URL_A + 'createUserLog',
  getUserLog: BASE_URL_A + 'getUserLog',
  getAllUserLog: BASE_URL_A + 'getAllUserLog',
  updateUserLog: BASE_URL_A + 'updateUserLog',
  deleteUserLog: BASE_URL_A + 'deleteUserLog',

  // Create Lead Space
  createLeadSpace: BASE_URL_A + 'createLeadSpace',
  getAllLeadSpace: BASE_URL_A + 'getAllLeadSpace',
  updateLeadSpace: BASE_URL_A + 'updateLeadSpace',
  deleteLeadSpace: BASE_URL_A + 'deleteLeadSpace',

  // communication section start
  CreateCommunicationHisLog: BASE_URL_B + 'createCommunicationHisLog',
  sendEmail: BASE_URL_B + 'sendEmailUsingSES',
  getCommunicationHisLog: BASE_URL_B + 'getCommunicationHisLog',
  UpdateCommunicationHisLog: BASE_URL_B + 'updateCommunicationHisLog',

  // evetn section start

  getAllEvents: BASE_URL_B + 'getAllEvent',
  createEvent: BASE_URL_B + 'createEvent',
  updateEvent: BASE_URL_B + 'updateEvent',
  deleteEvent: BASE_URL_B + 'deleteEvent',

  // event section end

  // whatsapp template section start

  getAllWhatsappTemplates: BASE_URL_B + 'getAllTemplateWithPagination',
  getAppId: BASE_URL_B + 'getWhatsappConfig',
  createWhatsappTemplate: BASE_URL_B + 'createWhatsappTemplate',
  getAllLanguages: BASE_URL_B + 'getAllLanguage',
  updateWhatsappTemplate: BASE_URL_B + 'updateGupshupTemplate',
  deleteWhatsappTemplate: BASE_URL_B + 'deleteTemplateByTemplateId',
  refreshGupshupTemplates: BASE_URL_B + 'bulkUpdateWhasappTemplateStatus',

  // whatsapp template section end

  // email template section start

  getAllEmaiTemplate: BASE_URL_B + 'getAllEmailTemplate',
  createEmailTemplate: BASE_URL_B + 'createEmailTemplate',
  deleteEmailTemplate: BASE_URL_B + 'deleteEmailTemplate',
  updateEmailTemplate: BASE_URL_B + 'updateEmailTemplate',

  // email template section end

  // contact group section start

  getAllContactGroups: BASE_URL_A + 'getAllContact_group',
  createContactGroup: BASE_URL_A + 'createContact_group',
  createContactGroupList: BASE_URL_B + 'createContactGroupList',
  getAllContactGroupList: BASE_URL_B + 'getAllContactGroupList',
  getCampaignSkipCount: BASE_URL_E + 'getCampaignSkipCount',
  getLeadAndContactId: BASE_URL_B + 'getLeadAndContactId',
  updateContactGroup: BASE_URL_A + 'updateContact_group',
  deleteContactGroup: BASE_URL_A + 'deleteContact_group',

  // contact group section end

  // manage campaign section start

  getAllManangeCampaign: BASE_URL_A + 'getAllCampaign',
  getAllWhatsappTemplatesGupshup: BASE_URL_B + 'getGupshupTemplate',
  createCampaign: BASE_URL_A + 'createCampaign',
  runCampaign: BASE_URL_B + 'campaignBroadcast',
  deleteCampaign: BASE_URL_A + 'deleteCampaign',
  updateCampaign: BASE_URL_A + 'updateCampaign',
  getAllEmailTemplates: BASE_URL_B + 'getEmailTemplate',
  getGupshuTemplateById: BASE_URL_B + 'getGupshupTemplateById',
  getEmailTemplateById: BASE_URL_B + 'getEmailTemplateById',
  getAllTemplatesWithStatusFilter:
    BASE_URL_B + 'getAllTemplatesWithStatusFilter',
  testCampaignEmail: BASE_URL_B + 'testCampaignEmail',
  testCampaignWhatsapp: BASE_URL_B + 'testCampaignWhatsapp',
  // manage campaign section end

  // outlook email hub section start
  outlookInboxEmail: BASE_URL_B + 'outlookInboxEmail',
  outlookSentEmail: BASE_URL_B + 'outlookSentEmail',
  outlookDraftEmail: BASE_URL_B + 'outlookDraftEmail',
  outlookJunkEmail: BASE_URL_B + 'outlookJunkEmail',
  deleteOutlookEmail: BASE_URL_B + 'deleteOutlookEmail',
  deleteOutlookEmailPermanently: BASE_URL_B + 'deleteOutlookEmailPermanently',
  outlookDeletedEmail: BASE_URL_B + 'outlookDeletedEmail',
  sendEmailUsingOutlook: BASE_URL_B + 'sendEmailUsingOutlook',
  getOutlookEmailWithAttachment: BASE_URL_B + 'getOutlookEmailWithAttachment',
  createOutlookDraftEmail: BASE_URL_B + 'createOutlookDraftEmail',
  updateOutlookDraftEmail: BASE_URL_B + 'updateOutlookDraftEmail',
  sendOutlookDraftEmail: BASE_URL_B + 'sendOutlookDraftEmail',
  createOutlookReply: BASE_URL_B + 'createOutlookReply',
  sendOutlookReply: BASE_URL_B + 'sendOutlookReply',
  createOutlookReplyAll: BASE_URL_B + 'createOutlookReplyAll',
  forwardOutlookEmail: BASE_URL_B + 'forwardOutlookEmail',
  getOutlookEmailAttachments: BASE_URL_B + 'getOutlookEmailAttachments',
  addAttachmentInOutlookReply: BASE_URL_B + 'addAttachmentInOutlookReply',
  deleteAttachmentInOutlook: BASE_URL_B + 'deleteAttachmentInOutlook',
  getCodeForOutlookToken: BASE_URL_C + 'getCodeForOutlookToken',
  revokeAccess: BASE_URL_C + 'disconnectOutlook',

  // outlook email hub section end

  // gmail mail hub (part-d) — same paths as serverless.yml
  gmailInboxEmail: BASE_URL_D + 'gmailInboxEmail',
  gmailSentEmail: BASE_URL_D + 'gmailSentEmail',
  gmailDraftEmail: BASE_URL_D + 'gmailDraftEmail',
  gmailSpamEmail: BASE_URL_D + 'gmailSpamEmail',
  gmailTrashEmail: BASE_URL_D + 'gmailTrashEmail',
  sendEmailUsingGmail: BASE_URL_D + 'sendEmailUsingGmail',
  deleteGmailEmail: BASE_URL_D + 'deleteGmailEmail',
  deleteGmailEmailPermanently: BASE_URL_D + 'deleteGmailEmailPermanently',
  getGmailEmailWithAttachment: BASE_URL_D + 'getGmailEmailWithAttachment',
  createGmailDraftEmail: BASE_URL_D + 'createGmailDraftEmail',
  updateGmailDraftEmail: BASE_URL_D + 'updateGmailDraftEmail',
  sendGmailDraftEmail: BASE_URL_D + 'sendGmailDraftEmail',
  deleteGmailDraftEmail: BASE_URL_D + 'deleteGmailDraftEmail',
  createGmailReplyDraft: BASE_URL_D + 'createGmailReplyDraft',
  createGmailReplyAllDraft: BASE_URL_D + 'createGmailReplyAllDraft',
  sendGmailReplyEmail: BASE_URL_D + 'sendGmailReplyEmail',
  forwardGmailEmail: BASE_URL_D + 'forwardGmailEmail',
  getGmailEmailAttachments: BASE_URL_D + 'getGmailEmailAttachments',
  getConnectedGmailEmail: BASE_URL_D + 'getConnectedGmailEmail',
  getCodeForGoogleToken: BASE_URL_D + 'getCodeForGoogleToken',
  disconnectGmail: BASE_URL_D + 'disconnectGmail',

  // ticket section start
  upload: UPLOAD_URL,
  createTicket: BASE_URL_B + 'createTicket',
  updateTicket: BASE_URL_B + 'updateTicket',
  getAllTinaTicket: BASE_URL_B + 'getAllTicket',
  getFilteredTickets: BASE_URL_B + 'getFilteredTickets',
  deleteTicket: BASE_URL_B + 'deleteTicket',
  updateBulkTicket: BASE_URL_B + 'updateMultipleTicket',
  addTicketComment: BASE_URL_B + 'createTicketComment',
  getAllTicketComments: BASE_URL_B + 'getAllTicketCommentById',
  updateTicketComment: BASE_URL_B + 'updateTicketComment',

  getTinaTicketHistory: BASE_URL_B + 'getAllTicketHistory',
  getUsers: BASE_URL_B + 'getAlluser',
  updateTicketHistory: BASE_URL_B + 'createTicketHistory',
  createBulkTicketHistory: BASE_URL_B + 'createBulkTicketHis',
  getAllZendeskTicket:
    'https://pxdoxmhdzj.execute-api.us-east-1.amazonaws.com/production/zendeskListTickets',
  // ticket section end

  // Company section start
  getAllCompany: BASE_URL_A + 'getAllAccount',
  createCompany: BASE_URL_A + 'createAccount',
  updateCompany: BASE_URL_A + 'updateAccount',
  deleteCompany: BASE_URL_A + 'deleteAccount',
  createBulkAccount: BASE_URL_C + 'createBulkAccount',
  getAllAccount: BASE_URL_A + 'getAccount',
  // Company section end

  // delas section start
  getAllDeal: BASE_URL_B + 'getAllDeal',
  createDeal: BASE_URL_B + 'createDeal',
  updateDeal: BASE_URL_B + 'updateDeal',
  deleteDeal: BASE_URL_B + 'deleteDeal',
  getDealsAnalytics: BASE_URL_B + 'getDealAnalytics',

  // delas section end

  // invoice section start
  getAllInvoice: BASE_URL_C + 'getAllInvoice',
  createInvoice: BASE_URL_C + 'createInvoice',
  updateInvoice: BASE_URL_C + 'updateInvoice',
  deleteInvoice: BASE_URL_C + 'deleteInvoice',
  getInvoiceAnalytics: BASE_URL_C + 'getInvoiceAnalytics',
  sendInvoice: BASE_URL_C + 'sendInvoice',
  generateInvoice: BASE_URL_C + 'generateInvoice',
  // invoice section end

  // quote section start
  getAllQuote: BASE_URL_C + 'getAllQuote',
  createQuote: BASE_URL_C + 'createQuote',
  updateQuote: BASE_URL_C + 'updateQuote',
  deleteQuote: BASE_URL_C + 'deleteQuote',
  getQuoteAnalytics: BASE_URL_C + 'getQuoteAnalytics',
  sendQuote: BASE_URL_C + 'sendQuote',
  generateQuote: BASE_URL_C + 'generateQuote',
  // quote section end

  // contact section start
  getAllContactWithCount: BASE_URL_A + 'getAllContactWithCount',
  createContact: BASE_URL_A + 'createContact',
  updateContact: BASE_URL_A + 'updateContact',
  deleteContact: BASE_URL_A + 'deleteContact',
  // contact section end

  // pipeline section start
  getAllPipeLine: BASE_URL_B + 'getAllPipeline',
  createPipeLine: BASE_URL_B + 'createPipeline',
  updatePipeLine: BASE_URL_B + 'updatePipeline',
  deletePipeLine: BASE_URL_B + 'deletePipeline',
  // pipeline section end

  // Product section start
  getAllProduct: BASE_URL_B + 'getAllProduct',
  addProduct: BASE_URL_B + 'createProduct',
  updateProduct: BASE_URL_B + 'updateProduct',
  deleteProduct: BASE_URL_B + 'deleteProduct',
  // Product section end

  // category section start
  getAllCategory: BASE_URL_B + 'getAllCategory',
  createCategory: BASE_URL_B + 'createCategory',
  updateCategory: BASE_URL_B + 'updateCategory',
  deleteCategory: BASE_URL_B + 'deleteCategory',
  // category section end

  // taxes section start
  getAllTaxe: BASE_URL_C + 'getAllTaxe',
  createTaxe: BASE_URL_C + 'createTaxe',
  updateTaxe: BASE_URL_C + 'updateTaxe',
  deleteTaxe: BASE_URL_C + 'deleteTaxe',
  // taxes section end

  // lead task section start
  getAllTasks: BASE_URL_A + 'getAllTask',
  createTask: BASE_URL_A + 'createTask',
  updateTask: BASE_URL_A + 'updateTask',
  deleteTask: BASE_URL_A + 'deleteTask',

  // lead task section end

  // notes section start

  getAllNotes: BASE_URL_B + 'getAllNote',
  createNote: BASE_URL_B + 'createNote',
  updateNote: BASE_URL_B + 'updateNote',
  deleteNote: BASE_URL_B + 'deleteNote',

  // notes section end

  // lead activity timeline (part-d)
  createLeadActivityLog: BASE_URL_D + 'createLeadActivityLog',
  getAllLeadActivity: BASE_URL_D + 'getAllLeadActivity',
  createSupportRecord: BASE_URL_D + 'createSupportRecord',
  getSupportRecords: BASE_URL_D + 'getSupportRecords',
  backfillLeadActivity: BASE_URL_D + 'backfillLeadActivity',

  // customer 360 (part-d)
  captureCustomerActivity: BASE_URL_D + 'captureCustomerActivity',
  extractCustomerActivityDocument:
    BASE_URL_D + 'extractCustomerActivityDocument',
  uploadCustomerCaptureDocument: BASE_URL_D + 'uploadCustomerCaptureDocument',
  getCustomerTransactions: BASE_URL_D + 'getCustomerTransactions',
  getCustomerLoyalty: BASE_URL_D + 'getCustomerLoyalty',
  getCustomerOffers: BASE_URL_D + 'getCustomerOffers',
  getCustomerBehaviorSummary: BASE_URL_D + 'getCustomerBehaviorSummary',
  getCustomerProfile: BASE_URL_D + 'getCustomerProfile',
  getLeadIdByCustomerId: BASE_URL_D + 'getLeadIdByCustomerId',
  getLeadCustomerAnalytics: BASE_URL_D + 'getLeadCustomerAnalytics',
  getLeadCustomerIntelligence: BASE_URL_D + 'getLeadCustomerIntelligence',
  customerIntelligenceUrl,
  customerIntelligenceAudienceUrl,
  receiptOcrUrl,
  receiptOcrApiKey,
  getCustomerBehaviorAnalytics: BASE_URL_D + 'getCustomerBehaviorAnalytics',
  getCustomerFeedback: BASE_URL_D + 'getCustomerFeedback',
  createCustomerFeedback: BASE_URL_D + 'createCustomerFeedback',
  getCustomerDocuments: BASE_URL_D + 'getCustomerDocuments',
  createCustomerDocument: BASE_URL_D + 'createCustomerDocument',

  // part-e (meeting booking, customer fetch, WhatsApp)
  getSalesTeamWithSlots: BASE_URL_E + 'getSalesTeamWithSlots',
  getMeetingSlots: BASE_URL_E + 'getMeetingSlots',
  bookMeetingSlot: BASE_URL_E + 'bookMeetingSlot',
  rescheduleMeetingSlot: BASE_URL_E + 'rescheduleMeetingSlot',
  cancelMeetingSlot: BASE_URL_E + 'cancelMeetingSlot',
  getandBookMeetingSlot: BASE_URL_E + 'getandBookMeetingSlot',
  getAllMeetingDetails: BASE_URL_E + 'getAllMeetingDetails',
  fetchCustomerTransactions: BASE_URL_E + 'fetchCustomerTransactions',
  fetchLoyaltyTransactions: BASE_URL_E + 'fetchLoyaltyTransactions',
  fetchCustomerFeedback: BASE_URL_E + 'fetchCustomerFeedback',

  // team section start
  getAllTeam: BASE_URL_A + 'getAllTeam',
  createTeam: BASE_URL_A + 'createTeam',
  updateTeam: BASE_URL_A + 'updateTeam',
  deleteTeam: BASE_URL_A + 'deleteTeam',
  getAllTeamMembers: BASE_URL_A + 'getAllTeamMember',
  createTeamMember: BASE_URL_A + 'createTeamMember',
  deleteTeamMember: BASE_URL_A + 'deleteTeamMember',
  // team section end

  // forecast section start
  getAllForecast: BASE_URL_A + 'getAllForecast',
  createForecast: BASE_URL_A + 'createForecast',
  updateForecast: BASE_URL_A + 'updateForecast',
  deleteForecast: BASE_URL_A + 'deleteForecast',
  getAllDealByUser: BASE_URL_B + 'getAllDealByUser',
  getforecastAnalytics: BASE_URL_A + 'getforecastAnalytics',
  // forecast section end
  createSequence: BASE_URL_A + 'createSequence',
  updateSequence: BASE_URL_A + 'updateSequence',
  updateSequenceCounter: BASE_URL_A + 'updateSequenceCounter',
  getSequence: BASE_URL_A + 'getSequence',
  getAllSequence: BASE_URL_A + 'getAllSequence',
  getAllSequenceWithCount: BASE_URL_A + 'getAllSequenceWithCount',

  createSequenceSchedule: BASE_URL_A + 'createSequenceSchedule',
  updateSequenceSchedule: BASE_URL_A + 'updateSequenceSchedule',
  getSequenceSchedule: BASE_URL_A + 'getSequenceSchedule',
  getAllSequenceSchedule: BASE_URL_A + 'getAllSequenceSchedule',

  createSequenceTask: BASE_URL_A + 'createSequenceTask',
  updateSequenceTask: BASE_URL_A + 'updateSequenceTask',
  getSequenceTask: BASE_URL_A + 'getSequenceTask',
  getAllSequenceTask: BASE_URL_A + 'getAllSequenceTask',
  getAllSequenceTaskWithCount: BASE_URL_A + 'getAllSequenceTaskWithCount',

  // clinet domain section start
  authenticateClientDomain: BASE_URL_C + 'authenticateClientDomain',
  domainVeriicationStatus: BASE_URL_C + 'domainVerificationStatus',
  updateClientDomain: BASE_URL_C + 'updateClientDomain',
  getAllClientDomain: BASE_URL_C + 'getAllClientDomain',
  verifyDomainEmail: BASE_URL_C + 'verifyDomainEmail',
  deleteDomainAndEmail: BASE_URL_C + 'deleteDomainAndEmail',
  deleteSequenceTask: BASE_URL_A + 'deleteSequenceTask',
  deleteSequence: BASE_URL_A + 'deleteSequence',
  checkForMailConfigConnection: BASE_URL_C + 'checkForMailConfigConnection',

  // account section starts
  getAccountFields: BASE_URL_C + 'getAccountField',
  createAccountField: BASE_URL_C + 'createAccountField',
  deleteAccountField: BASE_URL_C + 'deleteAccountField',
  updateAccountField: BASE_URL_C + 'updateAccountField',
  // account section ends

  // contact section starts
  createContactField: BASE_URL_C + 'createContactField',
  getContactField: BASE_URL_C + 'getContactField',
  deleteContactField: BASE_URL_C + 'deleteContactField',
  updateContactField: BASE_URL_C + 'updateContactField',
  createBulkContact: BASE_URL_C + 'createBulkContact',
  getAllContact: BASE_URL_A + 'getAllContact',

  createContactGroupListByLeadSpace:
    BASE_URL_C + 'createContactGroupListByLeadSpace',
  deleteDuplicateLeads: BASE_URL_C + 'deleteDuplicateLeads',
  exportLeadsToS3: BASE_URL_C + 'exportLeadsToS3',
  getApiToken: BASE_URL_C + 'getApiToken',

  //project APIs
  getAllProject: BASE_URL_D + 'getAllProject',
  createProject: BASE_URL_D + 'createProject',
  updateProject: BASE_URL_D + 'updateProject',
  deleteProject: BASE_URL_D + 'deleteProject',
  getProjectById: BASE_URL_D + 'getProjectById',
  getProjects: BASE_URL_D + 'getProjects',
  getProjectMembers: BASE_URL_D + 'getProjectMembers',

  //Bugs APIs
  getAllBugs: BASE_URL_D + 'getAllBug',
  createBug: BASE_URL_D + 'createBug',
  updateBug: BASE_URL_D + 'updateBug',
  deleteBug: BASE_URL_D + 'deleteBug',
  getBugById: BASE_URL_D + 'getBugById',
  getBugs: BASE_URL_D + 'getBugs',
  getBugActivityLog: BASE_URL_D + 'getBugActivity',

  //report APIs
  projectReport: BASE_URL_D + 'projectReport',
  bugsByProject: BASE_URL_D + 'bugsByProject',
  bugsByUser: BASE_URL_D + 'bugsByUser',
  bugsGrouped: BASE_URL_D + 'bugsGrouped',
  bugsByModule: BASE_URL_D + 'bugsByModule',
  bugBYTrend: BASE_URL_D + 'bugBYTrend',
  getProjectModuleList: BASE_URL_D + 'getProjectModuleList',
  createProjectModule: BASE_URL_E + 'createProjectModule',
  updateProjectModule: BASE_URL_E + 'updateProjectModule',
  deleteProjectModule: BASE_URL_E + 'deleteProjectModule',

  // report APIs Project Task start
  taskReportSummary: BASE_URL_D + 'taskReportSummary',
  tasksByUser: BASE_URL_D + 'tasksByUser',
  tasksByModule: BASE_URL_D + 'tasksByModule',
  taskTrend: BASE_URL_D + 'taskTrend',
  taskTimeLogReport: BASE_URL_D + 'taskTimeLogReport',
  // report APIs Project Task end

  // Epic, Feature, and User Story APIs (Part-E Stack)
  createEpic: BASE_URL_E + 'createEpic',
  updateEpic: BASE_URL_E + 'updateEpic',
  getEpicById: BASE_URL_E + 'getEpicById',
  getAllEpics: BASE_URL_E + 'getAllEpics',
  deleteEpic: BASE_URL_E + 'deleteEpic',
  getProjectHierarchy: BASE_URL_E + 'getProjectHierarchy',

  createFeature: BASE_URL_E + 'createFeature',
  updateFeature: BASE_URL_E + 'updateFeature',
  getFeatureById: BASE_URL_E + 'getFeatureById',
  getAllFeatures: BASE_URL_E + 'getAllFeatures',
  deleteFeature: BASE_URL_E + 'deleteFeature',

  createUserStory: BASE_URL_E + 'createUserStory',
  updateUserStory: BASE_URL_E + 'updateUserStory',
  getUserStoryById: BASE_URL_E + 'getUserStoryById',
  getAllUserStories: BASE_URL_E + 'getAllUserStories',
  deleteUserStory: BASE_URL_E + 'deleteUserStory',

  // Sprints APIs
  createSprint: BASE_URL_E + 'createSprint',
  updateSprint: BASE_URL_E + 'updateSprint',
  getSprintById: BASE_URL_E + 'getSprintById',
  getAllSprints: BASE_URL_E + 'getAllSprints',
  deleteSprint: BASE_URL_E + 'deleteSprint',

  // Project Tasks APIs
  getAllProjectTasks: BASE_URL_D + 'getAllProjectTasks',
  createProjectTask: BASE_URL_D + 'createProjectTask',
  updateProjectTask: BASE_URL_D + 'updateProjectTask',
  deleteProjectTask: BASE_URL_D + 'deleteProjectTask',
  getProjectTaskById: BASE_URL_D + 'getProjectTaskById',
  updateProjectTaskStatus: BASE_URL_D + 'updateProjectTaskStatus',

  // Project Task Items APIs
  createTaskItem: BASE_URL_D + 'createTaskItem',
  updateTaskItem: BASE_URL_D + 'updateTaskItem',
  getAllTaskItems: BASE_URL_D + 'getAllTaskItems',
  getTaskItemById: BASE_URL_D + 'getTaskItemById',
  deleteTaskItem: BASE_URL_D + 'deleteTaskItem',
  updateTaskItemStatus: BASE_URL_D + 'updateTaskItemStatus',

  // Project Task Comments APIs
  createTaskComment: BASE_URL_D + 'createTaskComment',
  updateTaskComment: BASE_URL_D + 'updateTaskComment',
  getAllTaskComments: BASE_URL_D + 'getAllTaskComments',
  getTaskCommentById: BASE_URL_D + 'getTaskCommentById',
  deleteTaskComment: BASE_URL_D + 'deleteTaskComment',

  // Project Task Time Logs APIs
  createTaskTimeLog: BASE_URL_D + 'createTaskTimeLog',
  updateTaskTimeLog: BASE_URL_D + 'updateTaskTimeLog',
  getAllTaskTimeLogs: BASE_URL_D + 'getAllTaskTimeLogs',
  getTaskTimeLogById: BASE_URL_D + 'getTaskTimeLogById',
  deleteTaskTimeLog: BASE_URL_D + 'deleteTaskTimeLog',

  // Project Task Activity APIs
  getTaskActivities: BASE_URL_D + 'getAllTaskActivities',

  getWhatsappConfig:
    'https://7l3rsnlkak.execute-api.us-east-1.amazonaws.com/dev/' +
    'getWhatsappConfig',
  uploadGupshupMedia:
    'https://okxvsyvxq1.execute-api.us-east-1.amazonaws.com/prod/uploadMedia',
  deleteContactGroupList: BASE_URL_B + 'deleteContactGroupList',
  addContactToGroupList: BASE_URL_B + 'createContactGroupList',
  updateContactGroupList: BASE_URL_B + 'updateContactGroupList',
  // client config APIs
  createClientConfig: BASE_URL_C + 'createClientConfig',
  updateClientConfig: BASE_URL_C + 'updateClientConfig',
  getAllClientConfig: BASE_URL_C + 'getAllClientConfig',
  getClientConfigById: BASE_URL_C + 'getClientConfigById',
  deleteClientConfig: BASE_URL_C + 'deleteClientConfig',
  createActiveDirectoryConfig: BASE_URL_C + 'createActiveDirectoryConfig',
  getActiveDirectoryConfigByClientId:
    BASE_URL_C + 'getActiveDirectoryConfigByClientId',
  updateActiveDirectoryConfig: BASE_URL_C + 'updateActiveDirectoryConfig',
  deleteActiveDirectoryConfig: BASE_URL_C + 'deleteActiveDirectoryConfig',
  getOutlookToken: BASE_URL_C + 'getOutlookToken',
  getConnectedOutlookEmail: BASE_URL_C + 'getConnectedOutlookEmail',
  getCurrentUserActivePackage: BASE_URL_C + 'getCurrentUserActivePackage',
  getAllPackage: BASE_URL_C + 'getAllPackage',
  getAllBillingInvoices: BASE_URL_C + 'getAllPackageInvoices',
  getAllPackageAddon: BASE_URL_C + 'getAllPackageAddon',
  getCampaignTracking: BASE_URL_C + 'getCampaignTracking',
  getMarketingAnalytics: BASE_URL_F + 'getMarketingAnalytics',

  // ── Workflow Automation (part-g) ────────────────────────────────────────────
  createWorkflow: BASE_URL_G + 'createWorkflow',
  getAllWorkflows: BASE_URL_G + 'getAllWorkflows',
  getWorkflow: BASE_URL_G + 'getWorkflow',
  getWorkflowRuns: BASE_URL_G + 'getWorkflowRuns',
  updateWorkflow: BASE_URL_G + 'updateWorkflow',
  updateWorkflowStatus: BASE_URL_G + 'updateWorkflowStatus',
  deleteWorkflow: BASE_URL_G + 'deleteWorkflow',

  getCampaignEngagement: BASE_URL_D + 'getCampaignEngagement',
  getReputation: BASE_URL_D + 'getReputation',
  getWhatsappCampaignTracking: BASE_URL_C + 'getWhatsappCampaignTracking',
  proformaPackageInvoice: BASE_URL_C + 'proformaPackageInvoice',
  cancelPendingPlanChange: BASE_URL_E + 'cancelPendingPlanChange',
  schedulePlanChange: BASE_URL_E + 'schedulePlanChange',
  proformaAddonInvoice: BASE_URL_C + 'proformaAddonInvoice',
  createAddonSubscription: BASE_URL_C + 'createAddonSubscription',
  getAllAddonSubscription: BASE_URL_C + 'getAllAddonSubscription',
  updateAddonSubscription: BASE_URL_C + 'updateAddonSubscription',
  getAddonSubscriptionById: BASE_URL_C + 'getAddonSubscriptionById',
  deleteAddonSubscription: BASE_URL_C + 'deleteAddonSubscription',
  createPackageSubscription: BASE_URL_C + 'createPackageSubscription',
  updatePackageSubscription: BASE_URL_C + 'updatePackageSubscription',
  getCurrentPackageFeatureAccess: BASE_URL_C + 'getCurrentPackageFeatureAccess',
  startOnboarding: BASE_URL_D + 'startOnboarding',
  verifyOnboarding: BASE_URL_D + 'verifyOnboarding',
  completeOnboarding: BASE_URL_D + 'completeOnboarding',

  submitCustomerDataDeletionRequest:
    BASE_URL_E + 'submitCustomerDataDeletionRequest',
  getCustomerDataDeletionRequests:
    BASE_URL_E + 'getCustomerDataDeletionRequests',
  getCustomerDataDeletionRequestStatus:
    BASE_URL_E + 'getCustomerDataDeletionRequestStatus',

  getCrmIntegrations: BASE_URL_E + 'getCrmIntegrations',
  saveCrmIntegration: BASE_URL_E + 'saveCrmIntegration',
  testCrmIntegration: BASE_URL_E + 'testCrmIntegration',
  disconnectCrmIntegration: BASE_URL_E + 'disconnectCrmIntegration',
  syncCrmIntegrationLeads: BASE_URL_E + 'syncCrmIntegrationLeads',

  // Web Live Chat (part-e — custom chat, no AWS Connect)
  createWebChatLead: BASE_URL_E + 'createWebChatLead',
  startWebChat: BASE_URL_E + 'startWebChat',
  sendWebChatMessage: BASE_URL_E + 'sendWebChatMessage',
  getWebChatMessages: BASE_URL_E + 'getWebChatMessages',
  endWebChat: BASE_URL_E + 'endWebChat',
  getWebChatQueue: BASE_URL_E + 'getWebChatQueue',
  takeoverWebChat: BASE_URL_E + 'takeoverWebChat',
  resolveWebChat: BASE_URL_E + 'resolveWebChat',
  uploadWebChatAttachment: BASE_URL_E + 'uploadWebChatAttachment',
  getWebChatAttachmentUrl: BASE_URL_E + 'getWebChatAttachmentUrl',
  /** WebSocket API base. Local offline: ws://localhost:3001/dev */
  webChatWsUrl: 'wss://wwnzo0qhuj.execute-api.us-east-1.amazonaws.com/dev',
  /** Set to ws://localhost:3001/dev when running part-e via npm start */
  // webChatWsUrl: 'ws://localhost:3001/dev',

  /** @deprecated aliases — use createWebChatLead / startWebChat / … */
  createLiveChatLead: BASE_URL_E + 'createWebChatLead',
  startConnectChat: BASE_URL_E + 'startWebChat',
  sendConnectChatMessage: BASE_URL_E + 'sendWebChatMessage',
  endConnectChat: BASE_URL_E + 'endWebChat',
  uploadConnectChatAttachment: BASE_URL_E + 'uploadWebChatAttachment',
  getConnectChatAttachmentUrl: BASE_URL_E + 'getWebChatAttachmentUrl',

  /** Base URL for public chat-widget.js embed (no trailing slash). */
  chatWidgetScriptBase: 'https://crm.innovategrav.com',

  // WhatsApp Live Chat section
  getWaConversations: BASE_URL_D + 'getWaConversations',
  getWaConversationMessages: BASE_URL_D + 'getWaConversationMessages',
  takeoverConversation: BASE_URL_D + 'takeoverConversation',
  releaseConversation: BASE_URL_D + 'releaseConversation',
  resolveConversation: BASE_URL_D + 'resolveConversation',
  sendWaAgentMessage: BASE_URL_D + 'sendWaAgentMessage',
  getWaConversationStats: BASE_URL_D + 'getWaConversationStats',
  getPendingLiveSessions: BASE_URL_D + 'getPendingLiveSessions',

  // ── HRM - Employee (part-f) ───────────────────────────────────────────────
  createEmployee: BASE_URL_F + 'createEmployee',
  updateEmployee: BASE_URL_F + 'updateEmployee',
  getAllEmployees: BASE_URL_F + 'getAllEmployees',
  getEmployeeById: BASE_URL_F + 'getEmployeeById',
  deleteEmployee: BASE_URL_F + 'deleteEmployee',
  updateEmployeeStatus: BASE_URL_F + 'updateEmployeeStatus',
  uploadEmployeeDocument: BASE_URL_F + 'uploadEmployeeDocument',
  getEmployeeDocuments: BASE_URL_F + 'getEmployeeDocuments',

  // ── HRM - Shift (part-f) ──────────────────────────────────────────────────
  createShift: BASE_URL_F + 'createShift',
  getAllShifts: BASE_URL_F + 'getAllShifts',
  updateShift: BASE_URL_F + 'updateShift',
  deleteShift: BASE_URL_F + 'deleteShift',
  assignEmployeeShift: BASE_URL_F + 'assignEmployeeShift',

  // ── HRM - Organization (part-f) ──────────────────────────────────────────
  getAllDepartmentsHRM: BASE_URL_F + 'getAllDepartmentsHRM',
  updateDepartmentHRM: BASE_URL_F + 'updateDepartmentHRM',
  createDesignation: BASE_URL_F + 'createDesignation',
  updateDesignation: BASE_URL_F + 'updateDesignation',
  getAllDesignations: BASE_URL_F + 'getAllDesignations',
  deleteDesignation: BASE_URL_F + 'deleteDesignation',
  createBranch: BASE_URL_F + 'createBranch',
  updateBranch: BASE_URL_F + 'updateBranch',
  getAllBranches: BASE_URL_F + 'getAllBranches',
  getOrgHierarchy: BASE_URL_F + 'getOrgHierarchy',

  // ── HRM - Attendance (part-f) ────────────────────────────────────────────
  clockIn: BASE_URL_F + 'clockIn',
  clockOut: BASE_URL_F + 'clockOut',
  getDailyAttendance: BASE_URL_F + 'getDailyAttendance',
  autoMarkDailyAttendance: BASE_URL_F + 'autoMarkDailyAttendance',
  getAttendanceReport: BASE_URL_F + 'getAttendanceReport',
  submitCorrectionRequest: BASE_URL_F + 'submitCorrectionRequest',
  approveCorrectionRequest: BASE_URL_F + 'approveCorrectionRequest',
  getPendingCorrections: BASE_URL_F + 'getPendingCorrections',

  // ── HRM - Leave (part-f) ─────────────────────────────────────────────────
  createLeaveType: BASE_URL_F + 'createLeaveType',
  getAllLeaveTypes: BASE_URL_F + 'getAllLeaveTypes',
  getLeaveBalance: BASE_URL_F + 'getLeaveBalance',
  applyLeave: BASE_URL_F + 'applyLeave',
  approveLeave: BASE_URL_F + 'approveLeave',
  rejectLeave: BASE_URL_F + 'rejectLeave',
  cancelLeave: BASE_URL_F + 'cancelLeave',
  getLeaveRequests: BASE_URL_F + 'getLeaveRequests',
  getLeaveReport: BASE_URL_F + 'getLeaveReport',
  allocateLeaveBalance: BASE_URL_F + 'allocateLeaveBalance',
  syncAllLeaveAccruals: BASE_URL_F + 'syncAllLeaveAccruals',

  // ── HRM - Holiday (part-f) ───────────────────────────────────────────────
  createHoliday: BASE_URL_F + 'createHoliday',
  updateHoliday: BASE_URL_F + 'updateHoliday',
  deleteHoliday: BASE_URL_F + 'deleteHoliday',
  getHolidayCalendar: BASE_URL_F + 'getHolidayCalendar',

  // ── Campaign segment types (part-f) ──────────────────────────────────────
  createCampaignSegmentType: BASE_URL_F + 'createCampaignSegmentType',
  updateCampaignSegmentType: BASE_URL_F + 'updateCampaignSegmentType',
  getAllCampaignSegmentTypes: BASE_URL_F + 'getAllCampaignSegmentTypes',
  deleteCampaignSegmentType: BASE_URL_F + 'deleteCampaignSegmentType',
  previewWhatsappNumberCheck: BASE_URL_F + 'previewWhatsappNumberCheck',
  checkWhatsappNumbers: BASE_URL_F + 'checkWhatsappNumbers',
  deleteNonWhatsappContacts: BASE_URL_F + 'deleteNonWhatsappContacts',

  // ── HRM - Dashboards (part-f) ────────────────────────────────────────────
  getHRDashboardStats: BASE_URL_F + 'getHRDashboardStats',
  getMyDashboard: BASE_URL_F + 'getMyDashboard',
  getMyProfile: BASE_URL_F + 'getMyProfile',
  checkEmployeeEnrollment: BASE_URL_F + 'checkEmployeeEnrollment',
  updateMyProfile: BASE_URL_F + 'updateMyProfile',

  // ── HRM - Employee Profile Sub-Tables (part-f) ───────────────────────────
  getFullEmployeeProfile: BASE_URL_F + 'getFullEmployeeProfile',
  // Employee Contacts (prefixed to avoid conflict with CRM contacts module)
  addEmpContact: BASE_URL_F + 'addEmpContact',
  updateEmpContact: BASE_URL_F + 'updateEmpContact',
  deleteEmpContact: BASE_URL_F + 'deleteEmpContact',
  getEmpContacts: BASE_URL_F + 'getEmpContacts',
  // Addresses
  addAddress: BASE_URL_F + 'addAddress',
  updateAddress: BASE_URL_F + 'updateAddress',
  deleteAddress: BASE_URL_F + 'deleteAddress',
  getAddresses: BASE_URL_F + 'getAddresses',
  // Family Members
  addFamilyMember: BASE_URL_F + 'addFamilyMember',
  updateFamilyMember: BASE_URL_F + 'updateFamilyMember',
  deleteFamilyMember: BASE_URL_F + 'deleteFamilyMember',
  getFamilyMembers: BASE_URL_F + 'getFamilyMembers',
  // Education
  addEducation: BASE_URL_F + 'addEducation',
  updateEducation: BASE_URL_F + 'updateEducation',
  deleteEducation: BASE_URL_F + 'deleteEducation',
  getEducation: BASE_URL_F + 'getEducation',
  // Experience
  addExperience: BASE_URL_F + 'addExperience',
  updateExperience: BASE_URL_F + 'updateExperience',
  deleteExperience: BASE_URL_F + 'deleteExperience',
  getExperience: BASE_URL_F + 'getExperience',
  // Skills
  addSkill: BASE_URL_F + 'addSkill',
  updateSkill: BASE_URL_F + 'updateSkill',
  deleteSkill: BASE_URL_F + 'deleteSkill',
  getSkills: BASE_URL_F + 'getSkills',
  // Bank Details
  addBankDetail: BASE_URL_F + 'addBankDetail',
  updateBankDetail: BASE_URL_F + 'updateBankDetail',
  deleteBankDetail: BASE_URL_F + 'deleteBankDetail',
  getBankDetails: BASE_URL_F + 'getBankDetails',
  // Employee Documents (dedicated table)
  addEmpDocument: BASE_URL_F + 'addEmpDocument',
  updateEmpDocument: BASE_URL_F + 'updateEmpDocument',
  deleteEmpDocument: BASE_URL_F + 'deleteEmpDocument',
  getEmpDocuments: BASE_URL_F + 'getEmpDocuments',
  // Assets (Employee profile tab)
  addAsset: BASE_URL_F + 'addAsset',
  updateAsset: BASE_URL_F + 'updateAsset',
  deleteAsset: BASE_URL_F + 'deleteAsset',
  getAssets: BASE_URL_F + 'getAssets',

  // ── HRM Phase 2: Payroll (part-g) ──────────────────────────────────────────
  createSalaryComponent: BASE_URL_G + 'createSalaryComponent',
  getAllSalaryComponents: BASE_URL_G + 'getAllSalaryComponents',
  updateSalaryComponent: BASE_URL_G + 'updateSalaryComponent',
  deleteSalaryComponent: BASE_URL_G + 'deleteSalaryComponent',
  createSalaryTemplate: BASE_URL_G + 'createSalaryTemplate',
  getAllSalaryTemplates: BASE_URL_G + 'getAllSalaryTemplates',
  updateSalaryTemplate: BASE_URL_G + 'updateSalaryTemplate',
  calculateSalaryBreakdown: BASE_URL_G + 'calculateSalaryBreakdown',
  assignEmployeeSalaryStructure: BASE_URL_G + 'assignEmployeeSalaryStructure',
  getEmployeeSalaryStructure: BASE_URL_G + 'getEmployeeSalaryStructure',
  getAllEmployeeSalaryStructures: BASE_URL_G + 'getAllEmployeeSalaryStructures',
  deleteEmployeeSalaryStructure: BASE_URL_G + 'deleteEmployeeSalaryStructure',
  createPayrollRun: BASE_URL_G + 'createPayrollRun',
  getAllPayrollRuns: BASE_URL_G + 'getAllPayrollRuns',
  getPayrollRunById: BASE_URL_G + 'getPayrollRunById',
  updatePayrollRunStatus: BASE_URL_G + 'updatePayrollRunStatus',
  getAllPayslips: BASE_URL_G + 'getAllPayslips',
  getPayslipById: BASE_URL_G + 'getPayslipById',
  getMyPayslips: BASE_URL_G + 'getMyPayslips',
  updatePayslipStatus: BASE_URL_G + 'updatePayslipStatus',
  generatePayslipPdf: BASE_URL_G + 'generatePayslipPdf',
  sendPayslipEmail: BASE_URL_G + 'sendPayslipEmail',

  // ── HRM Phase 2: Timesheets (part-g) ───────────────────────────────────────
  createTimesheet: BASE_URL_G + 'createTimesheet',
  submitTimesheet: BASE_URL_G + 'submitTimesheet',
  approveTimesheet: BASE_URL_G + 'approveTimesheet',
  rejectTimesheet: BASE_URL_G + 'rejectTimesheet',
  getAllTimesheets: BASE_URL_G + 'getAllTimesheets',
  getMyTimesheets: BASE_URL_G + 'getMyTimesheets',
  getTimesheetById: BASE_URL_G + 'getTimesheetById',
  deleteTimesheet: BASE_URL_G + 'deleteTimesheet',

  // ── HRM Phase 2: Expenses (part-g) ─────────────────────────────────────────
  createExpenseCategory: BASE_URL_G + 'createExpenseCategory',
  getAllExpenseCategories: BASE_URL_G + 'getAllExpenseCategories',
  updateExpenseCategory: BASE_URL_G + 'updateExpenseCategory',
  deleteExpenseCategory: BASE_URL_G + 'deleteExpenseCategory',
  createExpense: BASE_URL_G + 'createExpense',
  updateExpense: BASE_URL_G + 'updateExpense',
  submitExpense: BASE_URL_G + 'submitExpense',
  approveExpense: BASE_URL_G + 'approveExpense',
  rejectExpense: BASE_URL_G + 'rejectExpense',
  reimburseExpense: BASE_URL_G + 'reimburseExpense',
  getAllExpenses: BASE_URL_G + 'getAllExpenses',
  getMyExpenses: BASE_URL_G + 'getMyExpenses',
  getExpenseById: BASE_URL_G + 'getExpenseById',
  deleteExpense: BASE_URL_G + 'deleteExpense',

  // ── HRM Phase 2: Assets Master & Inventory (part-g) ────────────────────────
  createAssetCategory: BASE_URL_G + 'createAssetCategory',
  getAllAssetCategories: BASE_URL_G + 'getAllAssetCategories',
  updateAssetCategory: BASE_URL_G + 'updateAssetCategory',
  deleteAssetCategory: BASE_URL_G + 'deleteAssetCategory',
  createMasterAsset: BASE_URL_G + 'createAsset',
  updateMasterAsset: BASE_URL_G + 'updateMasterAsset',
  getAllMasterAssets: BASE_URL_G + 'getAllAssets',
  getMasterAssetById: BASE_URL_G + 'getAssetById',
  deleteMasterAsset: BASE_URL_G + 'deleteMasterAsset',
  assignAsset: BASE_URL_G + 'assignAsset',
  returnAsset: BASE_URL_G + 'returnAsset',
  getMyAssets: BASE_URL_G + 'getMyAssets',
  getAssetHistory: BASE_URL_G + 'getAssetHistory',
};
